import React from 'react'
import Header from "../../components/header/index";
import InnerHeader from "../../components/comment/innerHeader/innerHeader";
import SavedCardContent from './savedcardcontent/savedCardContent';
import Footer from "../../components/footer";


const savedcard = () => {
  return (
    <div className="main">
    <Header />
    <InnerHeader title="Saved Card " />
    <SavedCardContent />
    <Footer />
  </div>
  )
}

export default savedcard